import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Grid } from "@material-ui/core";
import crStyles from "../../../customerReservation/crStyles";
import sharedStyles from "../OrderDetailsNewVersion.module.scss";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import styles from "./HandOver.module.scss";
import CheckBox from "../../../../shared/checkBox/CheckBox";
import checkboxStyles from "../../../../shared/checkBox/CheckBox.module.scss";
import FormControl from "@material-ui/core/FormControl";
import HandOverCompleteDialog from "./HandOverCompleteDialog";
import {
  HANDOVER_DIALOGUES,
  HANDOVER_STATUS,
  HANDOVER_TYPES,
} from "./Constants";
import SharedToolTip from "../../../../shared/sharedToolTip/SharedToolTip";
import HandOverReleaseCommsDialog from "./HandOverReleaseCommsDialog";
import HandOverAppointmentDialog from "./HandOverAppointmentDialog";
import UiDateUtils from "../../../../utils/UiDateUtils";
import HandOverCancelAppointmentDialog from "./HandOverCancelAppointmentDialog";
import LowerCaseText from "../../../../utils/LowerCaseText";
import {
  CASH,
  FINANCE,
  LEASE,
  OFFLINEFINANCE,
  OFFLINELEASE,
  OFFLINEPRIVATELEASE,
} from "../../../../common/Constants";
import {
  StyledBasicExpansionPanel,
  StyledBasicExpansionPanelSummary,
} from "../../../../shared/ExpansionPanels/ExpansionPanel";
import CustomerReservationsClient from "../../../../shared/clients/CustomerReservationsClient";
import { base64FileDownload } from "../../../../utils/FileDownloadUtil";
import { IS_AGENT_DEALERTYPE } from "../../../../utils/EmpUtil";
import UpperCaseText from "../../../../utils/UpperCaseText";
import { logMsg } from "../../../../common/Logger";

class HandOver extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandHandOver: false,
      tooltipOpen: false,
      handOverToolTipOpen: false,
      dialogBoxes: {},
      checkBoxes: {},
      appointments: {},
      preferredAppointmentDate:
        this.props.customerReservation &&
        this.props.customerReservation.todayDate
          ? this.props.customerReservation.todayDate
          : null,
      preferredAppointmentTime: null,
      fromReschedule: false,
      canActionHandover: this.canActionHandover(),
    };
  }

  componentDidMount() {
    this.fetchAndVerifyHandoverCheckList();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.customerReservation !== this.props.customerReservation) {
      this.setState({ canActionHandover: this.canActionHandover() });
    }
  }

  handleDialogChange = (openKey, closeKey, chkBoxKey, chkBoxValue) => {
    const dialogBoxes = { ...this.state.dialogBoxes };
    const checkBoxes = { ...this.state.checkBoxes };

    if (openKey) dialogBoxes[openKey] = true;
    if (closeKey) dialogBoxes[closeKey] = false;
    if (chkBoxKey) checkBoxes[chkBoxKey] = !!chkBoxValue;

    this.setState({ dialogBoxes, checkBoxes, fromReschedule: false });
  };

  handleTooltipOpen = () => {
    this.setState((prevState) => ({
      tooltipOpen: !prevState.tooltipOpen,
    }));
  };

  toggleHandOverToolTip = (event) => {
    event.stopPropagation();
    this.setState((prevState) => ({
      handOverToolTipOpen: !prevState.handOverToolTipOpen,
    }));
  };

  checkPaymentStatus = () => {
    const customerReservation = this.props.customerReservation;
    if (customerReservation && customerReservation.paymentType) {
      const paymentType = customerReservation.paymentType;
      if (LowerCaseText(paymentType) === OFFLINEFINANCE) {
        return (
          customerReservation.contractSignedData &&
          customerReservation.contractSignedData.dealerAcceptedDate
        );
      } else if (LowerCaseText(paymentType) === FINANCE) {
        return (
          customerReservation.downPaymentPaidData &&
          customerReservation.downPaymentPaidData.paymentDate
        );
      } else if (
        LowerCaseText(paymentType) === OFFLINELEASE ||
        LowerCaseText(paymentType) === OFFLINEPRIVATELEASE
      ) {
        return (
          customerReservation.contractSignedData &&
          customerReservation.contractSignedData.dealerAcceptedDate
        );
      } else if (LowerCaseText(paymentType) === LEASE) {
        return customerReservation.balancePaymentData.paymentDate;
      } else if (LowerCaseText(paymentType) === CASH) {
        return (
          customerReservation.finalPaymentConfirmedData &&
          customerReservation.finalPaymentConfirmedData.dealerAcceptedDate &&
          customerReservation.finalPaymentConfirmedData.dealerActionUserId
        );
      } else return false;
    } else return false;
  };

  expandHandOver = () => {
    this.setState({ expandHandOver: !this.state.expandHandOver });
  };

  hideOrShowDetails = (id) => {
    const appointments = { ...this.state.appointments };
    appointments[id] = !appointments[id];
    this.setState({ appointments });
  };

  getTooltipBody() {
    return (
      <div className={styles.body}>
        <div className={styles.text}>
          {this.props.t("HandOver.openCommsTooltipText")}
        </div>
        <ul>
          <li>{this.props.t("HandOver.openCommsTooltipBullet1")}</li>
          <li>{this.props.t("HandOver.openCommsTooltipBullet2")}</li>
          <li>{this.props.t("HandOver.openCommsTooltipBullet3")}</li>
          <li>{this.props.t("HandOver.openCommsTooltipBullet4")}</li>
          <li>{this.props.t("HandOver.openCommsTooltipBullet5")}</li>
        </ul>
      </div>
    );
  }

  displayAppointmentInfo(data) {
    if (data && data.appointmentInfoData) {
      return data.appointmentInfoData
        .filter(
          (appointmentInfo) =>
            appointmentInfo !== null &&
            appointmentInfo.appointmentStatus !== null
        )
        .filter(
          (appointmentInfo) =>
            appointmentInfo.appointmentStatus === HANDOVER_STATUS.REQUESTED ||
            appointmentInfo.appointmentStatus === HANDOVER_STATUS.CANCELLED ||
            appointmentInfo.appointmentStatus === HANDOVER_STATUS.ACCEPTED
        )
        .map((appointmentInfo, index) => {
          const id = `${appointmentInfo.appointmentStatus}_${index}`;
          if (appointmentInfo.appointmentStatus === HANDOVER_STATUS.REQUESTED) {
            return (
              <>
                <Grid
                  container
                  className={styles.info}
                  data-testid={id + "Info"}
                >
                  <Grid
                    item
                    xs={1}
                    className={styles.dateInfo}
                    data-testid={id + "InfoDate"}
                  >
                    {UiDateUtils.formatYYYYMMDDToEUWithoutTime(
                      appointmentInfo.dealerActionDate
                    )}
                  </Grid>
                  <Grid item xs={11}>
                    <span className={styles.textInfo}>
                      {this.props.t(
                        "HandOver.handOverAppointmentCustomerRequested"
                      )}
                    </span>
                    <span
                      className={styles.link}
                      onClick={() => this.hideOrShowDetails(id)}
                      data-testid={id + "hideOrShow"}
                    >
                      {this.state.appointments[id]
                        ? this.props.t(
                            "HandOver.handOverAppointmentHideDetails"
                          )
                        : this.props.t(
                            "HandOver.handOverAppointmentShowDetails"
                          )}
                    </span>
                  </Grid>
                </Grid>
                {this.state.appointments[id] && (
                  <div data-testid={id + "details"}>
                    <Grid container className={styles.info}>
                      <Grid item xs={1} />
                      <Grid item xs={11} className={styles.textInfo}>
                        <span data-testid={id + "detailsDateText"}>
                          {this.props.t("HandOver.handOverAppointmentDate")}
                        </span>
                        <span className={styles.hyphen}>-</span>
                        <span
                          className={styles.hyphen}
                          data-testid={id + "detailsDate"}
                        >
                          {UiDateUtils.formatYYYYMMDDToEUWithoutTime(
                            appointmentInfo.preferredAppointmentDate
                          )}
                        </span>
                      </Grid>
                    </Grid>
                    <Grid container className={styles.info}>
                      <Grid item xs={1} />
                      <Grid item xs={11}>
                        <span
                          className={styles.textInfo}
                          data-testid={id + "detailsTimeSlotText"}
                        >
                          {this.props.t("HandOver.handOverAppointmentTimeSlot")}
                        </span>
                        <span className={styles.hyphen}>-</span>
                        <span
                          className={styles.hyphen}
                          data-testid={id + "detailsTimeSlot"}
                        >
                          {appointmentInfo.preferredAppointmentTime}
                        </span>
                      </Grid>
                    </Grid>
                    <Grid container className={styles.info}>
                      <Grid item xs={1} />
                      <Grid item xs={11}>
                        <span
                          className={styles.textInfo}
                          data-testid={id + "commentsText"}
                        >
                          {this.props.t("HandOver.handOverAppointmentComments")}
                        </span>
                        <span
                          className={styles.hyphen}
                          data-testid={id + "comments"}
                        >
                          {appointmentInfo.preferredNotesToDealer}
                        </span>
                      </Grid>
                    </Grid>
                  </div>
                )}
              </>
            );
          } else {
            const isCancelled =
              appointmentInfo.appointmentStatus === HANDOVER_STATUS.CANCELLED;
            return (
              <>
                <Grid
                  container
                  className={styles.info}
                  data-testid={id + "Info"}
                >
                  <Grid
                    item
                    xs={1}
                    className={styles.dateInfo}
                    data-testid={id + "InfoDate"}
                  >
                    {UiDateUtils.formatYYYYMMDDToEUWithoutTime(
                      appointmentInfo.dealerActionDate
                    )}
                  </Grid>
                  <Grid item xs={11}>
                    <span
                      className={
                        isCancelled ? styles.redInfo : styles.greenInfo
                      }
                    >
                      {isCancelled
                        ? this.props.t("HandOver.handOverAppointmentCancelled")
                        : this.props.t("HandOver.handOverAppointmentBooked")}
                    </span>
                    <span
                      className={styles.link}
                      onClick={() => this.hideOrShowDetails(id)}
                      data-testid={id + "hideOrShow"}
                    >
                      {this.state.appointments[id]
                        ? this.props.t(
                            "HandOver.handOverAppointmentHideDetails"
                          )
                        : this.props.t(
                            "HandOver.handOverAppointmentShowDetails"
                          )}
                    </span>
                  </Grid>
                </Grid>
                {this.state.appointments[id] && (
                  <div data-testid={id + "details"}>
                    <Grid container className={styles.info}>
                      <Grid item xs={1} />
                      <Grid item xs={11}>
                        <span
                          className={styles.textInfo}
                          data-testid={id + "detailsDateText"}
                        >
                          {this.props.t("HandOver.handOverAppointmentDate")}
                        </span>
                        <span className={styles.hyphen}>-</span>
                        <span
                          className={styles.hyphen}
                          data-testid={id + "detailsDate"}
                        >
                          {UiDateUtils.formatYYYYMMDDToEUWithoutTime(
                            appointmentInfo.preferredAppointmentDate
                          )}
                        </span>
                      </Grid>
                    </Grid>
                    <Grid container className={styles.info}>
                      <Grid item xs={1} />
                      <Grid item xs={11}>
                        <span
                          className={styles.textInfo}
                          data-testid={id + "detailsTimeText"}
                        >
                          {this.props.t("HandOver.handOverAppointmentTime")}
                        </span>
                        <span className={styles.hyphen}>-</span>
                        <span
                          className={styles.hyphen}
                          data-testid={id + "detailsTime"}
                        >
                          {appointmentInfo.preferredAppointmentTime}
                        </span>
                      </Grid>
                    </Grid>
                  </div>
                )}
              </>
            );
          }
        });
    }
  }

  displayCompleteInfo(data) {
    if (data && data.appointmentInfoData) {
      return data.appointmentInfoData
        .filter(
          (appointmentInfo) =>
            appointmentInfo !== null &&
            appointmentInfo.appointmentStatus !== null
        )
        .filter(
          (appointmentInfo) =>
            appointmentInfo.appointmentStatus === HANDOVER_STATUS.RECEIVED
        )
        .map((appointmentInfo) => {
          return (
            <Grid container className={styles.info} data-testid="CompleteInfo">
              <Grid
                item
                xs={1}
                className={styles.dateInfo}
                data-testid="CompleteInfoDate"
              >
                {UiDateUtils.formatYYYYMMDDToEUWithoutTime(
                  appointmentInfo.dealerActionDate
                )}
              </Grid>
              <Grid item xs={11}>
                <span
                  className={styles.textInfo}
                  data-testid="CompleteInfoText"
                >
                  {this.props.t("HandOver.handOverCompleteComplete")}
                </span>
                <span className={styles.hyphen}>-</span>
                <span className={styles.name} data-testid="CompleteInfoUserId">
                  {appointmentInfo.dealerUserId}
                </span>
              </Grid>
            </Grid>
          );
        });
    }
  }

  displayCommsInfo(data) {
    if (data && data.appointmentInfoData) {
      return data.appointmentInfoData
        .filter(
          (appointmentInfo) =>
            appointmentInfo !== null &&
            appointmentInfo.appointmentStatus !== null
        )
        .filter(
          (appointmentInfo) =>
            appointmentInfo.appointmentStatus === HANDOVER_STATUS.INITIAL
        )
        .map((appointmentInfo) => {
          return (
            <Grid container className={styles.info} data-testid="commsInfo">
              <Grid
                item
                xs={1}
                className={styles.dateInfo}
                data-testid="commsInfoDate"
              >
                {UiDateUtils.formatYYYYMMDDToEUWithoutTime(
                  appointmentInfo.dealerActionDate
                )}
              </Grid>
              <Grid item xs={11}>
                <span className={styles.textInfo}>
                  {this.props.t("HandOver.requestHandOverEmailSentToCustomer")}
                </span>
                <span className={styles.hyphen}>-</span>
                <span className={styles.name}>
                  {appointmentInfo.dealerUserId}
                </span>
              </Grid>
            </Grid>
          );
        });
    }
  }

  displayCustmerAtDeliveryInfo(customerAtDeliveryData) {
    return (
      <Grid
        container
        className={styles.info}
        data-testid="customerAtDeliveryInfo"
      >
        {customerAtDeliveryData &&
          customerAtDeliveryData.modemConsentDateTime && (
            <>
              <Grid item xs={1}>
                <span
                  className={styles.dateInfo}
                  data-testid="customerAtDeliveryDate"
                >
                  {UiDateUtils.formatYYYYMMDDToEUWithoutTime(
                    customerAtDeliveryData.modemConsentDateTime
                  )}
                </span>
              </Grid>
              <Grid item xs={11}>
                <span className={styles.textInfo}>
                  {this.props.t("HandOver.customerAtDeliveryInfoText")}
                </span>
              </Grid>
            </>
          )}
      </Grid>
    );
  }

  rescheduleAppointment = (data) => {
    const acceptedAppointment = data.appointmentInfoData.filter(
      (appointmentInfo) =>
        appointmentInfo.appointmentStatus === HANDOVER_STATUS.ACCEPTED
    )[0];

    const dialogBoxes = { ...this.state.dialogBoxes };
    dialogBoxes[HANDOVER_DIALOGUES.APPOINTMENT] = true;

    this.setState({
      preferredAppointmentDate: acceptedAppointment.preferredAppointmentDate,
      preferredAppointmentTime: acceptedAppointment.preferredAppointmentTime,
      fromReschedule: true,
      dialogBoxes: dialogBoxes,
    });
  };
  fetchHandOverDeliveryNotes = () => {
    this.props.hideOrShow(true);
    CustomerReservationsClient.fetchHandOverDeliveryNotes(
      this.props.token,
      LowerCaseText(this.props.customerReservation.uid),
      UpperCaseText(this.props.customerReservation.vinNumber)
    )
      .then((result) => {
        if (
          result &&
          result.data &&
          result.data.toString().startsWith("data:application/pdf;base64")
        ) {
          base64FileDownload(
            result.data,
            "application/pdf",
            "DeliveryNotes.pdf"
          );
        }
      })
      .catch((errObj) => {
        if (errObj && errObj.message) {
          logMsg("the error is: ", errObj.message);
        }
        this.props.showErrorPopup(
          this.props.t("Error.processingErrorTitle"),
          this.props.t("Error.processingErrorMessage")
        );
      })
      .finally(() => {
        this.props.hideOrShow(false);
      });
  };

  fetchAndVerifyHandoverCheckList = () => {
    this.props.hideOrShow(true);
    CustomerReservationsClient.fetchHandOverDeliveryNotes(
      this.props.token,
      LowerCaseText(this.props.customerReservation.uid),
      UpperCaseText(this.props.customerReservation.vinNumber)
    )
      .then((result) => {
        if (
          result &&
          result.data &&
          result.data.message &&
          !result.data.toString().startsWith("data:application/pdf;base64")
        ) {
          if (result.data.message.startsWith("No checklist exist with VIN")) {
            // checklist link is not shown; no state update needed
          }
        }
      })
      .catch((errObj) => {
        if (errObj && errObj.message) {
          logMsg("the error is: ", errObj.message);
        }
        this.props.showErrorPopup(
          this.props.t("Error.processingErrorTitle"),
          this.props.t("Error.processingErrorMessage")
        );
      })
      .finally(() => {
        this.props.hideOrShow(false);
      });
  };

  canActionHandover() {
    if (
      !this.props.user.permissions.rolePermissions.hasOwnProperty(
        "handOver:write"
      )
    ) {
      return false;
    }

    return this.props.user.permissions.rolePermissions.hasOwnProperty(
      "handOverSkipCheck"
    )
      ? this.props.isOrderAccepted
      : !!this.checkPaymentStatus();
  }

  render() {
    const {
      handoverappointmentConfirmedData,
      supportingCustomerAtDeliveryData,
      pricingStack,
    } = this.props.customerReservation;

    let disableCount = 1;
    let requestHandOverChecked =
      this.state.checkBoxes[HANDOVER_DIALOGUES.RELEASE_COMMS];
    let handOverAppointmentChecked =
      this.state.checkBoxes[HANDOVER_DIALOGUES.APPOINTMENT];
    let handOverCompleteChecked =
      this.state.checkBoxes[HANDOVER_DIALOGUES.COMPLETE];

    if (
      handoverappointmentConfirmedData &&
      handoverappointmentConfirmedData.appointmentInfoData
    ) {
      const appointmentStatuses =
        handoverappointmentConfirmedData.appointmentInfoData
          .filter(
            (appointmentInfo) => appointmentInfo.appointmentStatus !== null
          )
          .map((appointmentInfo) => {
            return appointmentInfo.appointmentStatus;
          });
      if (appointmentStatuses) {
        if (appointmentStatuses.includes(HANDOVER_STATUS.INITIAL)) {
          requestHandOverChecked = true;
          disableCount = 2;
        }
        if (appointmentStatuses.includes(HANDOVER_STATUS.ACCEPTED)) {
          handOverAppointmentChecked = true;
          disableCount = 3;
        }
        if (appointmentStatuses.includes(HANDOVER_STATUS.RECEIVED)) {
          handOverCompleteChecked = true;
          disableCount = 4;
        }
      }
    }
    let handOverTitleExtn = null;

    if (pricingStack && pricingStack.handOverType) {
      handOverTitleExtn =
        pricingStack.handOverType === HANDOVER_TYPES.COLLECTION
          ? this.props.t("HandOver.collectAtDealerShip")
          : this.props.t("HandOver.delivery");
    }

    const dealerType = this.props.dealerType;

    return (
      <>
        <StyledBasicExpansionPanel
          defaultExpanded={false}
          onChange={this.expandHandOver}
        >
          {this.props.isOrderCancelled && (
            <div className={this.props.overlay} />
          )}
          <StyledBasicExpansionPanelSummary style={crStyles.headerBarNeutral}>
            <div className={sharedStyles.headerBar}>
              <div className={sharedStyles.boldHeaderWithToolTip}>
                {this.props.t("HandOver.title")}
                {handOverTitleExtn && (
                  <span data-testid="handOverTitleExtn">{` - ${handOverTitleExtn}`}</span>
                )}
                <SharedToolTip
                  openTestid="handOverToolTipOpen"
                  open={this.state.handOverToolTipOpen}
                  closeTooltip={this.toggleHandOverToolTip}
                  openTooltip={this.toggleHandOverToolTip}
                  body={this.props.t("HandOver.toolTip")}
                />
              </div>
              <div>
                {this.state.expandHandOver ? (
                  <ExpandLessIcon id="less" />
                ) : (
                  <ExpandMoreIcon id="more" />
                )}
              </div>
            </div>
            <br />
          </StyledBasicExpansionPanelSummary>
          <div className={styles.handOverBox}>
            <div className={styles.bottomBorder}></div>
            <FormControl>
              <div
                data-testid="customerAtDelivery"
                className={styles.checkBoxWrapper}
              >
                <CheckBox
                  id="chkBoxCustomerAtDelivery"
                  checked={true}
                  isDisabled={disableCount > 0 || !this.state.canActionHandover}
                  label={this.props.t("HandOver.customerAtDeliveryTitle")}
                  textClass={checkboxStyles.boldLabel}
                />
                {this.displayCustmerAtDeliveryInfo(
                  supportingCustomerAtDeliveryData
                )}
              </div>

              <div
                data-testid="requestHandOver"
                className={styles.checkBoxWrapper}
              >
                <div className={styles.wrapper}>
                  <CheckBox
                    id="chkBoxRequestHandOver"
                    checked={requestHandOverChecked}
                    isDisabled={
                      disableCount > 1 || !this.state.canActionHandover
                    }
                    label={this.props.t("HandOver.requestHandOverTitle")}
                    onChange={() =>
                      this.handleDialogChange(
                        HANDOVER_DIALOGUES.RELEASE_COMMS,
                        null,
                        HANDOVER_DIALOGUES.RELEASE_COMMS,
                        true
                      )
                    }
                    textClass={checkboxStyles.boldLabel}
                  />
                  <SharedToolTip
                    openTestid="openCommsTooltip"
                    closeTestid="closeCommsTooltip"
                    open={this.state.tooltipOpen}
                    closeTooltip={this.handleTooltipOpen}
                    openTooltip={this.handleTooltipOpen}
                    title={this.props.t("HandOver.openCommsTooltipTitle")}
                    body={this.getTooltipBody()}
                  />
                </div>
                {this.displayCommsInfo(handoverappointmentConfirmedData)}
              </div>

              {!IS_AGENT_DEALERTYPE(dealerType) && (
                <div
                  data-testid="handOverAppointment"
                  className={styles.checkBoxWrapper}
                >
                  <div className={styles.wrapper}>
                    <CheckBox
                      id="chkBoxHandOverAppointment"
                      checked={handOverAppointmentChecked}
                      isDisabled={
                        disableCount > 2 || !this.state.canActionHandover
                      }
                      label={this.props.t("HandOver.handOverAppointmentTitle")}
                      onChange={() =>
                        this.handleDialogChange(
                          HANDOVER_DIALOGUES.APPOINTMENT,
                          null,
                          HANDOVER_DIALOGUES.APPOINTMENT,
                          true
                        )
                      }
                      textClass={checkboxStyles.boldLabel}
                    />
                    {disableCount !== 4 &&
                      handOverAppointmentChecked &&
                      this.state.canActionHandover &&
                      disableCount > 2 && (
                        <span
                          className={styles.link}
                          onClick={() =>
                            this.rescheduleAppointment(
                              handoverappointmentConfirmedData
                            )
                          }
                        >
                          {this.props.t(
                            "HandOver.handOverAppointmentReschedule"
                          )}
                        </span>
                      )}
                  </div>
                  {this.displayAppointmentInfo(
                    handoverappointmentConfirmedData
                  )}
                </div>
              )}

              <div
                data-testid="handOverComplete"
                className={styles.checkBoxWrapper}
              >
                <CheckBox
                  id="chkBoxHandOverComplete"
                  checked={handOverCompleteChecked}
                  isDisabled={disableCount > 3 || !this.state.canActionHandover}
                  label={this.props.t("HandOver.handOverCompleteTitle")}
                  onChange={() =>
                    this.handleDialogChange(
                      HANDOVER_DIALOGUES.COMPLETE,
                      null,
                      HANDOVER_DIALOGUES.COMPLETE,
                      true
                    )
                  }
                  textClass={checkboxStyles.boldLabel}
                />
                {this.displayCompleteInfo(handoverappointmentConfirmedData)}
              </div>
            </FormControl>
          </div>
        </StyledBasicExpansionPanel>

        <HandOverCompleteDialog
          {...this.props}
          open={this.state.dialogBoxes[HANDOVER_DIALOGUES.COMPLETE]}
          handleDialogChange={this.handleDialogChange}
          dialogBoxes={this.state.dialogBoxes}
        />

        <HandOverReleaseCommsDialog
          {...this.props}
          open={this.state.dialogBoxes[HANDOVER_DIALOGUES.RELEASE_COMMS]}
          handleDialogChange={this.handleDialogChange}
          dialogBoxes={this.state.dialogBoxes}
        />

        <HandOverAppointmentDialog
          {...this.props}
          open={this.state.dialogBoxes[HANDOVER_DIALOGUES.APPOINTMENT]}
          handleDialogChange={this.handleDialogChange}
          dialogBoxes={this.state.dialogBoxes}
          preferredAppointmentDate={this.state.preferredAppointmentDate}
          preferredAppointmentTime={this.state.preferredAppointmentTime}
          fromReschedule={this.state.fromReschedule}
        />

        <HandOverCancelAppointmentDialog
          {...this.props}
          open={this.state.dialogBoxes[HANDOVER_DIALOGUES.CANCEL_APPOINTMENT]}
          handleDialogChange={this.handleDialogChange}
          dialogBoxes={this.state.dialogBoxes}
        />
      </>
    );
  }
}

export default withTranslation("emp")(HandOver);
